/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type DatasetNameAndSourceTypeDto = {
    datasetName: string;
    datasourceType: DatasetNameAndSourceTypeDto.datasourceType;
};

export namespace DatasetNameAndSourceTypeDto {

    export enum datasourceType {
        ATHENA = 'ATHENA',
        BIGQUERY = 'BIGQUERY',
        REDSHIFT = 'REDSHIFT',
        SNOWFLAKE = 'SNOWFLAKE',
        DATABRICKS = 'DATABRICKS',
        MSSQL = 'MSSQL',
        MYSQL = 'MYSQL',
        POSTGRES = 'POSTGRES',
        ORACLE = 'ORACLE',
        SYNAPSE = 'SYNAPSE',
        LOOKER = 'LOOKER',
        POWER_BI = 'POWER_BI',
        QUICKSIGHT = 'QUICKSIGHT',
        TABLEAU = 'TABLEAU',
        MICROSTRATEGY = 'MICROSTRATEGY',
        QLIK = 'QLIK',
        AIRFLOW = 'AIRFLOW',
        MWAA = 'MWAA',
        COMPOSER = 'COMPOSER',
        DBT = 'DBT',
        DBTCLOUD = 'DBTCLOUD',
        FIVETRAN = 'FIVETRAN',
        ADF = 'ADF',
        DATABRICKS_JOBS = 'DATABRICKS_JOBS',
        ATLAN = 'ATLAN',
        DECLARATIVE = 'DECLARATIVE',
        _UNKNOWN_ = '_UNKNOWN_',
    }


}
